import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import Booking from './icons/Booking';
import Expenses from './icons/Expenses';
import Crew from './icons/Crew';
import Fleet from './icons/Fleet';
import Marina from './icons/Marina';
import { GlobalStyles } from '../../GlobalStyles';
import ProtectedNav from './elements/ProtectedNav';
import Reload from './icons/Reload';
import { selectedYachtState } from '../../redux/slices/yachtSlice';
import { useSelector } from 'react-redux';
import { ReduxUpdater } from '../../redux/ReduxUpdater';
import { expensesReloadingState, menuCollapsedState } from '../../redux/slices/statusesSlice';
import { lastExpensesState } from '../../redux/slices/tsSlice';
import { SidebarClose } from 'lucide-react';
import Employees from './icons/Employees';
import { VERSION } from '../../Version';
import VerticalStretch from './elements/Forms/VerticalStretch';
import { GlobalConstants } from '../../GlobalConstants';

const SidebarContent = () => {
    const currentSelectedYachtState = useSelector(selectedYachtState);
    const areExpensesReloading = useSelector(expensesReloadingState);
    const lastExpensesUpdatedTS = useSelector(lastExpensesState);
    const isMenuCollapsed = useSelector(menuCollapsedState);

    const location = useLocation();
  
    React.useEffect(() => {
        setTimeout(() => {
            ReduxUpdater.expensesReloading = false;
        }, 250);
    }, [lastExpensesUpdatedTS]);

    return (
        
        <div data-layer="sidePanel" className="Sidepanel h-full w-[240px] p-4 bg-bg-sidebar border-r border-border-default inline-flex flex-col justify-start items-start overflow-y-auto">
            <div className="size- inline-flex justify-end items-end">
                <div className={GlobalStyles.menu.item}>
                    <div data-svg-wrapper data-layer="sideBarIcons" data-property-1="SidebarClose Icon" className="relative">
                        <button
                            className=""
                            onClick={() => {
                                ReduxUpdater.menuCollapsed = !isMenuCollapsed;
                            }}
                        >
                            <SidebarClose />
                        </button>
                    </div>
                </div>
            </div>
            {([GlobalConstants.UserRole.ROOT, GlobalConstants.UserRole.ADMIN].includes(ReduxUpdater.authenticatedUser?.user_role ?? '')) && <div className="size- inline-flex justify-start items-start">
                <div className={`${GlobalStyles.menu.item}${location.pathname === '/fleet' ? ' bg-bg-header' : ''}`}>
                    <div data-svg-wrapper data-layer="sideBarIcons" data-property-1="Boat Icon" className="relative">
                        <Fleet />
                    </div>
                    <NavLink to="/fleet" className="justify-center text-gray-800 text-sm font-normal font-['Inter'] leading-tight">Fleet</NavLink>
                    {/* <div className="flex-1 h-4 min-w-1 pl-20 inline-flex flex-col justify-start items-end" /> */}
                </div>
            </div>}
            {[GlobalConstants.UserRole.ROOT].includes(ReduxUpdater.authenticatedUser?.user_role ?? '') && <div className="size- inline-flex justify-start items-start">
                <div className={`${GlobalStyles.menu.item}${location.pathname === '/employees' ? ' bg-bg-header' : ''}`}>
                    <div data-svg-wrapper data-layer="sideBarIcons" data-property-1="Boat Icon" className="relative">
                        <Employees />
                    </div>
                    <NavLink to="/employees" className="justify-center text-gray-800 text-sm font-normal font-['Inter'] leading-tight">Employees</NavLink>
                    {/* <div className="flex-1 h-4 min-w-2 pl-20 inline-flex flex-col justify-start items-end" /> */}
                </div>
            </div>}
            {[GlobalConstants.UserRole.ROOT, GlobalConstants.UserRole.ADMIN].includes(ReduxUpdater.authenticatedUser?.user_role ?? '') && <div className="size- inline-flex justify-start items-start">
                <div className={`${GlobalStyles.menu.item}${location.pathname === '/crew' ? ' bg-bg-header' : ''}`}>
                    <div data-svg-wrapper data-layer="sideBarIcons" data-property-1="Crew Icon" className="relative">
                        <Crew stroke="black" />
                    </div>
                    <ProtectedNav to="/crew" labelOrElement="Crew" />
                    {/* <div className="flex-1 h-4 min-w-2 pl-20 inline-flex flex-col justify-start items-end" /> */}
                </div>
            </div>}
            <div className="size- inline-flex justify-start items-start">
                <div className="Menuitem w-[-webkit-fill-available] max-w-[200px] self-stretch px-1.5 py-2 rounded-lg flex justify-start items-center gap-2.5">
                    <div data-svg-wrapper data-layer="sideBarIcons" data-property-1="Expense" className="relative">
                        <Expenses />
                    </div>
                    <div className="justify-center text-gray-800 text-sm font-normal font-['Inter'] leading-tight active">Expenses</div>
                    <div className="float-right">
                        <div className="relative">
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.0703 10.043L8.07031 6.04297L4.07031 10.043" stroke="var(--colors-black, black)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            {/* {[GlobalConstants.UserRole.ROOT].includes(ReduxUpdater.authenticatedUser?.user_role ?? '') && <div className="size- inline-flex justify-start items-start">
                <div className={`${GlobalStyles.menu.subMenu}${location.pathname === '/upload' ? ' bg-bg-header' : ''}`}>
                    <ProtectedNav to="/upload" label="Upload" />
                    <div className="flex-1 h-4 min-w-2 pl-20 inline-flex flex-col justify-start items-end">
                        <button
                            // disabled={}
                            onClick={() => {
                                ReduxUpdater.reloadLastTransactionDate();
                            }}
                        >
                            <Reload height={12} />
                        </button>
                    </div>
                </div>
            </div>} */}
            {[GlobalConstants.UserRole.ROOT].includes(ReduxUpdater.authenticatedUser?.user_role ?? '') && <div className="size- inline-flex justify-start items-start">
                <div className={`${GlobalStyles.menu.subMenu}${location.pathname === '/integrations' ? ' bg-bg-header' : ''}`}>
                    <ProtectedNav to="/integrations" labelOrElement="Integrations" textSize='text-sm' />
                </div>
            </div>}
            <div className="size- inline-flex justify-start items-start">
                <div className={`group hover-over ${GlobalStyles.menu.subMenu}${location.pathname === '/expenses' ? ' bg-bg-header' : ''}`}>
                    <ProtectedNav to="/expenses" labelOrElement="Manage" textSize='text-sm' />
                    <div className="flex-1 h-4 min-w-2 pl-20 inline-flex flex-col justify-start items-end">
                        <button
                            className="hidden group-hover:visible group-hover:block"
                            disabled={!currentSelectedYachtState}
                            onClick={() => {
                                ReduxUpdater.reloadExpensesData();
                            }}
                        >
                            <div className={areExpensesReloading ? 'animate-spin' : ''}>
                                <Reload height={12} />
                            </div>
                        </button>
                    </div>
                </div>
            </div>
            <div className="size- inline-flex justify-start items-start">
                <div className={`group hover-over ${GlobalStyles.menu.subMenu}${location.pathname === '/reimbursements' ? ' bg-bg-header' : ''}`}>
                    <NavLink className="justify-center text-gray-800 text-sm font-normal font-['Inter'] leading-tight" to="/reimbursements">Reimbursements</NavLink>
                    {/* <div className="flex-1 h-4 min-w-2 pl-20 inline-flex flex-col justify-start items-end" /> */}
                </div>
            </div>
            <div className="size- inline-flex justify-start items-start">
                <div className={`${GlobalStyles.menu.subMenu}`}>
                    {/* <NavLink className="justify-center text-gray-800 text-sm font-normal font-['Inter'] leading-tight" to="/reports">Reports</NavLink> */}
                    <div className="justify-center text-gray-400 text-sm font-normal font-['Inter'] leading-tight">Reports</div>
                    {/* <div className="flex-1 h-4 min-w-2 pl-20 inline-flex flex-col justify-start items-end" /> */}
                </div>
            </div>
            <div className="size- inline-flex justify-start items-start">
                <div className={`${GlobalStyles.menu.subMenu}`}>
                    <div className="justify-center text-gray-400 text-sm font-normal font-['Inter'] leading-tight">Insights</div>
                    {/* <div className="flex-1 h-4 min-w-2 pl-20 inline-flex flex-col justify-start items-end" /> */}
                </div>
            </div>
            <div className="size- inline-flex justify-start items-start">
                <div className="Menuitem max-w-[200px] self-stretch px-1.5 py-2 rounded-lg flex justify-start items-center gap-2.5">
                    <div data-svg-wrapper data-layer="sideBarIcons" data-property-1="Calendar Icon" className="relative">
                        <Booking />
                    </div>
                    <div className="justify-center text-gray-400 text-sm font-normal font-['Inter'] leading-tight">Booking</div>
                    <div className="float-right">
                        <div className="relative">
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.0703 10.043L8.07031 6.04297L4.07031 10.043" stroke="var(--colors-black, black)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
            <div className="size- inline-flex justify-start items-start">
                <div className={`${GlobalStyles.menu.subMenu}${location.pathname === '/marina' ? ' bg-bg-header' : ''}`}>
                    <div data-svg-wrapper data-layer="sideBarIcons" data-property-1="Calendar Icon" className="relative">
                        <Marina />
                    </div>
                    <div className="justify-center text-gray-400 text-sm font-normal font-['Inter'] leading-tight">Marina</div>
                    {/* <div className="flex-1 h-4 min-w-2 pl-20 inline-flex flex-col justify-start items-end" /> */}
                </div>
            </div>
            <VerticalStretch />
            <div className="w-full text-[8px] text-center">{VERSION}</div>
        </div>
    );
};

export default SidebarContent;